import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <path d="M12 19.9998C7.589 19.9998 4 16.4108 4 11.9998C4 7.58876 7.589 3.99976 12 3.99976C16.411 3.99976 20 7.58876 20 11.9998C20 16.4108 16.411 19.9998 12 19.9998ZM12 1.99976C6.477 1.99976 2 6.47776 2 11.9998C2 17.5218 6.477 21.9998 12 21.9998C17.522 21.9998 22 17.5218 22 11.9998C22 6.47776 17.522 1.99976 12 1.99976Z" />
    <path d="M16 9C16 9.553 15.553 10 15 10C14.447 10 14 9.553 14 9C14 8.447 14.447 8 15 8C15.553 8 16 8.447 16 9Z" />
    <path d="M10 9C10 9.553 9.552 10 9 10C8.448 10 8 9.553 8 9C8 8.447 8.448 8 9 8C9.552 8 10 8.447 10 9Z" />
    <path d="M16.9001 12.9998C16.4361 15.2818 14.4191 16.9998 12.0001 16.9998C9.5811 16.9998 7.5631 15.2818 7.1001 12.9998" />
  </React.Fragment>,
  `Emoji`
);
